import { hasForms2 } from "../../js/helpers";

(function ($) {

    $(document).ready(() => {

        $('[block-name="marketo-form"]').map((index, block) => {
            const form = $(block).find('form');
            const id = form.attr('data-form-id');
            const type = $(block).attr('data-size');
            const variant = $(block).attr('data-variant');

            //Only run for standard variant, compact is handled by forms-modal.js
            if (hasForms2() && type === 'standard' && variant === 'marketo') {
                MktoForms2.loadForm("//app-sn03.marketo.com", "091-LWC-058", id);
                MktoForms2.whenReady(function (){
                    form.removeClass('loading');
                });
            }

            MktoForms2.whenReady(function(form) {
                form.onSuccess(function() {
                    setTimeout(function() {
                        $('.modal__content form').hide();
                        $('.modal-success').show();
                    }, 500)
                });
            })

        });
    });

})(jQuery);